// Recovered compiled webpack factory 46752. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      AppRouterContext: function () {
        return a;
      },
      GlobalLayoutRouterContext: function () {
        return i;
      },
      LayoutRouterContext: function () {
        return o;
      },
      MissingSlotContext: function () {
        return l;
      },
      TemplateContext: function () {
        return s;
      },
    }));
  let n = r(28140)._(r(12115)),
    a = n.default.createContext(null),
    o = n.default.createContext(null),
    i = n.default.createContext(null),
    s = n.default.createContext(null),
    l = n.default.createContext(new Set());
}
